// extracted by mini-css-extract-plugin
export default {"tooltip":"Tooltip--tooltip--cDOs1","label":"Tooltip--label--2QBug","arrow":"Tooltip--arrow--Y23GV"};